import React from "react";
import { FaAppStoreIos } from "react-icons/fa";
import { HiOutlineComputerDesktop } from "react-icons/hi2";
import { FaNode } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import ServicesCard from "./ServicesCard";
import { isItalianDevice } from "../../utils/utils";

const MyServices = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      <ServicesCard
        icons={<FaReact />}
        title="FrontEnd"
        subTitle={
          isItalianDevice()
            ? "ReactJS con Typescript e Flutter."
            : "ReactJS with Typescript and Flutter."
        }
      />
      <ServicesCard
        icons={<FaNode />}
        title="Backend"
        subTitle={
          isItalianDevice()
            ? "Principalmente con NodeJS ma ho utilizzato anche Spring boot."
            : "Mainly with NodeJS but with Spring boot too."
        }
      />
      <ServicesCard
        icons={<FaAppStoreIos />}
        title={isItalianDevice() ? "Sviluppo mobile" : "Mobile Development"}
        subTitle={
          isItalianDevice()
            ? "Amo sviluppare app android ed iOS con Flutter ma utilizzo anche android nativo."
            : "I'm in love with Flutter but I developer native android apps too."
        }
      />
      <ServicesCard
        icons={<HiOutlineComputerDesktop />}
        title={isItalianDevice() ? "Informatica" : "Computer Science"}
        subTitle={
          isItalianDevice()
            ? "Da sempre appassionato di informatica a 360 gradi, dall' hardware al software, dalle nuove schede video alle ultime distro Linux."
            : "Always an all-around computer enthusiast, from hardware to software, from new video cards to the latest Linux distros."
        }
      />
    </div>
  );
};

export default MyServices;
